// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const TosModalEffectiveDate = (props: { effectiveDate: Date }): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.tos.tosModalEffectiveDate"
        description="Tos modal effective date."
        defaultMessage="Effective: {effectiveDate, date, long}"
        values={props}
    />
);
TosModalEffectiveDate.displayName = "TosModalEffectiveDate";

export const TosModalAccept = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.tos.tosModalAccept"
        description="Tos modal accept."
        defaultMessage="Accept"
    />
);
TosModalAccept.displayName = "TosModalAccept";

export const TosModalDismiss = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.tos.tosModalDismiss"
        description="Tos modal dismiss."
        defaultMessage="Dismiss"
    />
);
TosModalDismiss.displayName = "TosModalDismiss";

export const TosLCRHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.tos.tosLCRHeader"
        description="Tos lcr header."
        defaultMessage="Snap Lens Creator Rewards Program Terms"
    />
);
TosLCRHeader.displayName = "TosLCRHeader";

export const TosLensPlusHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.tos.tosLensPlusHeader"
        description="Tos lens plus header."
        defaultMessage="Lens+ Program Terms"
    />
);
TosLensPlusHeader.displayName = "TosLensPlusHeader";

export const TosBannerMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.tos.tosBannerMessage"
        description="Tos banner message."
        defaultMessage="Review and accept the payout program terms to enroll your Lenses for payouts."
    />
);
TosBannerMessage.displayName = "TosBannerMessage";

export const TosBannerViewTerms = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.tos.tosBannerViewTerms"
        description="Tos banner view terms."
        defaultMessage="View Terms"
    />
);
TosBannerViewTerms.displayName = "TosBannerViewTerms";
